module.exports = __webpack_public_path__ + "img/map_austin_bg_4.7aef5c0c.jpg";